import { UseQueryOptions } from 'react-query';
import { getCreatedFeatures, getOrgFeatures } from './features.api';
import {
  CreatedFeaturesResponse,
  OrgFeaturesResponse,
} from './features.schema';

export const getCreatedFeaturesQuery =
  (): UseQueryOptions<CreatedFeaturesResponse> => ({
    queryKey: [{ scope: 'features', type: 'created' }],
    queryFn: () => getCreatedFeatures(),
  });

export const getOrgFeaturesQuery = (
  orgId: number,
): UseQueryOptions<OrgFeaturesResponse> => ({
  queryKey: [{ scope: 'features', type: 'org', orgId }],
  queryFn: () => getOrgFeatures(orgId),
  enabled: !!orgId,
});
